import React, { useRef } from "react";
import { FiMail } from "react-icons/fi";
import { AccountModalBody, AccountModalFooter, AccountModalHeader } from "./AccountModalParts";
import { forgotUser } from "../ForgotForm/ForgotForm.api";
import { toastrError, toastrSuccess } from "lib/toastr";
import { useTranslation } from "react-i18next";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "context/auth-context";
interface AccountToggleProps {
  isPopupOpen;
  isPopupOpen1
}

  const ResetPassword: React.FC<AccountToggleProps> = ({ isPopupOpen,isPopupOpen1 }) => {
  const { t } = useTranslation();
  const { auth } = useAuth();
  const ResetPasswordMutaion = useMutation(() => forgotUser(auth.email), {
    onSuccess: (response: any) => {
      if (response.success) {
        toastrSuccess(t("forgotPassword.success"));
      } else {
        toastrError(response.message);
      }
    },
    onError: () => {
      toastrError(t("page.unsubscribe.Encountered"));
    },
  });

  function handleReset(e) {
    e.preventDefault();
    ResetPasswordMutaion.mutate();
  }

  const modelRef = useRef();
  const CloseModal = (e) => {
    if (modelRef.current == e.target) {
      isPopupOpen();
     isPopupOpen1(); 
    }
  };
   const handleClose=()=>{
       isPopupOpen();
       isPopupOpen1();
  };

  return (
    <>
      {isPopupOpen && (
        <div
          className="zs-backdrop"
          ref={modelRef}
          onClick={CloseModal}
          role="dialog"
          aria-modal="true"
          aria-labelledby="account-reset-title"
        >
          <div className="zs-modal max-w-md">
            <AccountModalHeader titleId="account-reset-title" title={t("forgotPassword.head")} onClose={handleClose} />
            <AccountModalBody className="items-center text-center">
              <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary-soft text-primary-text">
                <FiMail className="w-7 h-7" />
              </span>
              <p className="text-sm text-ink-2">
                {t("forgotPassword.p1")}
                <span className="font-medium text-ink ml-0.5 break-all">{auth.email}</span>
              </p>
              <p className="text-sm text-ink-3">{t("forgotPassword.p2")}</p>
              <p className="text-sm font-medium text-primary-text">{t("forgotPassword.p3")}</p>
            </AccountModalBody>
            <AccountModalFooter className="sm:!justify-center">
              <button className="zs-btn zs-btn-soft" onClick={handleReset}>
                {t("forgotPassword.button")}
              </button>
            </AccountModalFooter>
          </div>
        </div>
      )}
    </>
  );
};

export default ResetPassword;
